import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { applicationNotesKey, errorMessage } from '@features/applicationNotes';
import { applicationNotesRoute } from '@features/applicationNotes/api/constants';
import { employerApplicationsKey, errorMessage } from '@features/applications';
import axiosInstance from '@server/axiosInstance';

type UseDeleteApplicationNoteProps = {
  applicationId: number;
  setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useDeleteApplicationNote = ({
  applicationId,
  setErrorText = () => {},
}: UseDeleteApplicationNoteProps) => {
  const client = useQueryClient();

  const { mutate: deleteNote, isLoading: isDeleteNoteLoading } = useMutation({
    mutationFn: (variables: { application_note_id: number }) =>
      axiosInstance
        .delete(applicationNotesRoute, { data: variables })
        .then((res) => res.data),
    onSuccess: (data) => {
      if (data.status !== 200) {
        setErrorText(data.message);
      } else {
        setErrorText('');
      }
      client.invalidateQueries([applicationNotesKey, applicationId]);
    },
    onError: () => {
      setErrorText(errorMessage);
    },
  });

  return {
    deleteNote,
    isDeleteNoteLoading,
  };
};
